import React from 'react';
import { useSpring, animated } from 'react-spring';

const OCountUp = ({ start, end, duration, prefix = '', suffix = '', decimals = 0, locale = 'es-ES' }) => {
    const { number } = useSpring({
        from: { number: start },
        number: end,
        config: { duration: duration * 1000 }
    });

    return (
        <animated.span>
            {number.to(n => `${prefix}${n.toLocaleString(locale, {
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals
            })}${suffix}`)}
        </animated.span>
    );
};

export default OCountUp;
